import publicConfig from "config/public";
import { FulfillmentPreference } from "custom-types/User";
import { useDispatch, useSelector } from "redux/hooks";
import { USER_FULFILLMENT_PREFERENCE_CHANGE } from "redux/reducers/user";
import { getUserFulfillmentPreference } from "redux/selectors/user";
import { setClientSideCookie } from "utils/cookies";

import useDomainCountryCode from "./useDomainCountryCode";

const useUserFulfillmentPreference = () => {
  const countryCode = useDomainCountryCode();
  const { cookieDomainCa, cookieDomain } = publicConfig;
  const dispatch = useDispatch();

  const setUserFulfillmentPreference = (preference: FulfillmentPreference) => {
    setClientSideCookie(
      "userFulfillmentPreference",
      preference || FulfillmentPreference.DELIVERY,
      countryCode === "CA" ? cookieDomainCa : cookieDomain,
    );

    dispatch({
      fulfillmentPreference: preference,
      type: USER_FULFILLMENT_PREFERENCE_CHANGE,
    });
  };

  return {
    setUserFulfillmentPreference,
    userFulfillmentPreference: useSelector(getUserFulfillmentPreference),
  };
};

export default useUserFulfillmentPreference;
